import _ from 'lodash/core'
import CommonService from './commonService'

class UtilService {

	posterCreator({bgImg, userImg, userName, title, dstUrl} = {}) {
		return CommonService.getjsonp({ body: {domain: 'yun.finger.inner',
																						uri: '/internal.poster.create',
																						bgImg, userImg, userName, title, dstUrl, language:'CN'} })
	}

	vipCardCreator({cardTitle, cardDesc, cardNo, cardDate, cardImg, dstUrl} = {}) {
		return CommonService.getjsonp({ body: {domain: 'yun.finger.inner',
																						uri: '/internal.vip.card.create',
																						cardTitle, cardDesc, cardNo, cardDate, cardImg, dstUrl, language:'CN'} })
	}

	recordData({iid, rid, type, p} = {}) {
		return CommonService.getjsonp({ body: {domain: 'api.finger.inner',
																						uri: '/v1/sys/stat',
																						iid, rid, type, p, language:'CN'} })

	}

}

// 实例化后再导出
export default new UtilService()
